import { render, staticRenderFns } from "./newDemandeDeCotationGazPro.vue?vue&type=template&id=8b2f47a4"
import script from "./newDemandeDeCotationGazPro.vue?vue&type=script&lang=js"
export * from "./newDemandeDeCotationGazPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports